import { render, staticRenderFns } from "./onfirmOrder.vue?vue&type=template&id=4b9dc6f2&scoped=true&"
import script from "./onfirmOrder.vue?vue&type=script&lang=js&"
export * from "./onfirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./onfirmOrder.vue?vue&type=style&index=0&id=4b9dc6f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9dc6f2",
  null
  
)

export default component.exports